import { DOMHelper } from "../Helpers/DOMHelper.js";
import { PmLogApi } from "../API/PmLogApi.js";

export class AdobeDtmDatalayer {

    constructor(pmdrs, vehicle) {
        this.pmdrs = pmdrs;
        this.vehicle = vehicle;
        this.enabled = false;
        this.providerName ='pixel motion';
        this.initiatedForms = {};// to remember and not double fire it
        this.pmLogApi = null;
        // this.leadIdsSubmitted = [];
    }

    /**
     * 
     * @returns boolean true if it's enabled 
     */
    init() {
        let st = this.pmdrs.config.accountId;
        const hasDigitalData = 'digitalData' in window;
        const hasNewEvent = hasDigitalData && typeof window.digitalData.newEvent === 'function';
        this.enabled = hasDigitalData && hasNewEvent;
        // this.enabled = true; // for dev
        // && ['speeddra2'].includes(st);//Site validation
        if(this.enabled){
            console.info("PmDrsAdobeDtm enabled");
            this.pmLogApi = new PmLogApi(this.pmdrs);
        }else if(!hasDigitalData){
            console.info("PmDrsAdobeDtm not enabled, window.digitalData not available");
        }else if(!hasNewEvent){
            console.info("PmDrsAdobeDtm not enabled, window.digitalData.newEvent is not a function");
        }
        return this.enabled;
    }

    fireEvent(eventName, params){        
        if(!this.enabled) return;//skip if not enabled

        // if(eventName === "formSubmit" && params?.leadId){
        //     if(this.leadIdsSubmitted.includes(params.leadId)){
        //         console.info(`AdobeDtmDatalayer: leadId ${params.leadId} already submitted, skipping duplicate formSubmission event.`);
        //         return;
        //     }
        //     this.leadIdsSubmitted.push(params.leadId);
        // }

        const functionName =  `_${eventName}Event`;
        if(typeof this[functionName] === 'function'){
            console.info("PmDrsAdobeDtm: " + eventName);
            const dtmEvent = this[functionName](params);
            console.log(dtmEvent)
        }
    }

    sendToAdobeDtm(dtmEvent) {
        window.digitalData.newEvent(dtmEvent);
        this.pmLogApi.send(dtmEvent, "adobedtm",
            (success) => {
                let rsp = JSON.parse(success);
                console.log(rsp);
            },
            (error) => {
                console.log(error)
            }
        );
    }

    _jsVirtualPageViewEvent({}) {
        var dtmEvent = {
            type: "CustomTagEvent",
            eventName: "JSVirtualPageView",
            eventAction: "contentView",
            attributes: {
                virtPageName: "dealer:us:digital-retailing:pixel-motion-overlay",
                virtPageType: "overlay",
                drtProvider: this.providerName
            },
        }
        dtmEvent = this.addVehicleAttribute(dtmEvent);
        this.sendToAdobeDtm(dtmEvent);
        return dtmEvent;
    }

    _buttonClickEvent({btnText}) {
        btnText = btnText.replaceAll(' ', "-").toLowerCase();
        var dtmEvent = {
            type: "CustomTagEvent",
            eventName: "CTA",

            eventAction: "buttonClick",
            attributes: {
                linkText: "digital-retailing:" + btnText,
                drtProvider: this.providerName
            },
        }
        dtmEvent = this.addVehicleAttribute(dtmEvent);
        this.sendToAdobeDtm(dtmEvent);
        return dtmEvent;
    }

    _closeDrsEvent() {
        this._buttonClickEvent({btnText:'pixel-motion-overlay-close'})
        var dtmEvent = {
            type: "CustomTagEvent",
            eventName: "pluginTool",
            eventAction: "close",
            attributes: {
                drtProvider: this.providerName
            }
        }
        dtmEvent = this.addVehicleAttribute(dtmEvent);
        this.sendToAdobeDtm(dtmEvent);
        return dtmEvent;
    }

    _formErrorEvent({errorMessage, errorType}) {
        var dtmEvent = {
            type: "CustomTagEvent",
            eventName: "error",
            attributes: {
                message: errorMessage,
                type: errorType || 'form-validation',
                drtProvider: this.providerName
            }
        }
        dtmEvent = this.addVehicleAttribute(dtmEvent);
        this.sendToAdobeDtm(dtmEvent);
        return dtmEvent;
    }

    _formInitEvent({formType}) {
        var dtmEvent = {
            type: "CustomTagEvent",
            eventName: "start",
            eventAction: "form",
            attributes: {
                formType: formType,
                displayType: 'modal',
                formDescription: 'non-lead',
                displayFormat: "digital-retailing",
                drtProvider: this.providerName
            }
        }
        dtmEvent = this.addVehicleAttribute(dtmEvent);
        this.sendToAdobeDtm(dtmEvent);
        return dtmEvent;
    }

    _toolStartEvent() {
        var dtmEvent = {
            type: "CustomTagEvent",
            eventName: "start",
            eventAction: "digital-retailing",
            attributes: {
                toolType: "digital-retailing:tool-start",
                displayType: "overlay",
                drtProvider: this.providerName
            }
        }
        dtmEvent = this.addVehicleAttribute(dtmEvent);
        this.sendToAdobeDtm(dtmEvent);
        return dtmEvent;
    }

    _toolSubmitEvent({leadId, hashedEmail}) {
        var dtmEvent = {
            type: "CustomTagEvent",
            eventName: "submit",
            eventAction: "digital-retailing",
            attributes: {
                toolType: "digital-retailing:tool-submit",
                displayType: "overlay",
                drtProvider: this.providerName,
                hashedEmail: hashedEmail,
                leadId: leadId
            },
        }
        dtmEvent = this.addVehicleAttribute(dtmEvent);
        this.sendToAdobeDtm(dtmEvent);
        return dtmEvent;
    }

    _formSubmitEvent({formType, leadId, hashedEmail, tradeInVehicle}) {
        this._toolSubmitEvent({leadId, hashedEmail});
        var dtmEvent = {
            type: "CustomTagEvent",
            eventName: "submit",
            eventAction: "form",
            attributes: {
                formType: formType,
                displayType: 'modal',
                formDescription: 'non-lead',
                displayFormat: "digital-retailing",
                drtProvider: this.providerName
                // hashedEmail: hashedEmail,//moved to tool submit, not needed here
                // leadId: leadId //moved to tool submit, not needed here
            }
        }
        if(tradeInVehicle && tradeInVehicle.make){
            dtmEvent.attributes.tradeInProvider = 'pixel-motion';//should we use the tradde in setting? crs chrome etc?
            dtmEvent.attributes.tradeInVehicleYear = tradeInVehicle.year;
            dtmEvent.attributes.tradeInVehicleMake = tradeInVehicle.make;
            dtmEvent.attributes.tradeInVehicleModel = tradeInVehicle.model;
            dtmEvent.attributes.desiredVehicleYear = this.vehicle.year;
            dtmEvent.attributes.desiredVehicleMake = this.vehicle.make;
            dtmEvent.attributes.desiredVehicleModel = this.vehicle.model;
        }
        dtmEvent = this.addVehicleAttribute(dtmEvent);
        this.sendToAdobeDtm(dtmEvent);
        return dtmEvent;
    }

    addVehicleAttribute(dtmEvent){
        const vehicle = this.vehicle;
        Object.assign(dtmEvent.attributes, {
            year: vehicle.year,
            make: vehicle.make,
            model: vehicle.model,
            vin: vehicle.vin,
            trim: vehicle.trim,
            inventoryStatus: vehicle.statusCode || "", //kzx, out_of_stock
            status: vehicle.condition // is status condition?
        });

        return dtmEvent;
    }

}

